import { combineReducers } from "redux";
import transmissionValidator from "./transmissionValidator";

export default combineReducers({ transmissionValidator });
